import { sendAnalytics } from '../utils/api';
import {
  FEEDBACK_EVENT_ORIGIN,
  ANALYTICS_EVENT_TYPE,
  FEEDBACK_EVENT_TYPE,
} from './analyticsEvents';

// eslint-disable-next-line no-unused-vars
const sendAnalyticsFeedbackEvent = (event) => async (dispatch, getState) => {
  if (!event) return;

  // Enrich the analytics data with context about user, url, time, etc
  const { user = {} } = getState();

  const eventData = {
    ...event,
    origin: FEEDBACK_EVENT_ORIGIN,
    host: window.location.host,
    path: window.location.pathname,
    event_ts: new Date().toISOString(),
    user_id: user.user_id || '',
  };

  await sendAnalytics(eventData);
};

// Send User Feedback events to the analytics pipeline.
// These should be feedback explicitly gathered from users.

export const sendFeedbackEvent = (event) => {
  if (!event) return undefined;
  event.eventType = FEEDBACK_EVENT_TYPE;
  return sendAnalyticsFeedbackEvent(event);
};

// Send User Analytics events to the analytics pipeline. These should be
// events generated by implicit user activity. This can include: navigation,
// sorting, page views, etc.

export const sendAnalyticsEvent = (event) => {
  if (!event) return undefined;
  event.eventType = ANALYTICS_EVENT_TYPE;
  return sendAnalyticsFeedbackEvent(event);
};
